import { defineComponent, ref } from 'vue';
import IconPng1 from '@/assets/image/home/icon-long-1-1.png';
import IconPng2 from '@/assets/image/home/icon-long-1-2.png';
import IconPng3 from '@/assets/image/home/icon-long-1-3.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import FeatureCard from './FeatureCard.vue';
export default defineComponent({
  name: 'FeatureArea',
  components: {
    EnvironmentOutlined: EnvironmentOutlined,
    FeatureCard: FeatureCard
  },
  setup: function () {
    var selectedKeys = ref([]);
    var route = useRoute();
    setKeys(route);
    var router = useRouter();
    router.afterEach(function (to) {
      setKeys(to);
    });
    var clickMenuItem = function (e) {
      var key2 = e.key;
      selectedKeys.value = [key2];
      router.push(key2);
    };
    function setKeys(to) {
      var path = to.path;
      // openKeys.value.push(path.slice(0, path.indexOf('/', 1)));
      selectedKeys.value = [path];
    }
    var linkItem = function (name) {
      var routeData = router.resolve({
        name: name
      });
      window.open(routeData.href, '_blank');
    };
    return {
      IconPng1: IconPng1,
      IconPng2: IconPng2,
      IconPng3: IconPng3,
      selectedKeys: selectedKeys,
      clickMenuItem: clickMenuItem,
      linkItem: linkItem
    };
  }
});